import React from "react";
import "../App.css";
import translations from "./translation.js";

const Level = ({ experience, language }) => {
    const levels = () => {
        if (experience > 15000) {
            return "Immortal";
        } else if (experience > 10000) {
            return "Mythic";
        } else if (experience > 6000) {
            return "Legendary";
        } else if (experience > 3000) {
            return "Heroic";
        } else if (experience > 1000) {
            return "Grandmaster";
        } else if (experience > 500) {
            return "Master";
        } else if (experience > 100) {
            return "Expert";
        } else if (experience > 50) {
            return "Journeyman";
        } else if (experience > 25) {
            return "Apprentice";
        } else if (experience > 5) {
            return "Novice";
        } else {
            return "Noob";
        }
        };
    
    
    return(
        <div style={{ fontFamily: "'Josefin Sans', 'KaiTi'", marginTop: '4px' }}>
            <span>{translations[language].level} {translations[language][levels()]}</span>
        </div>
    );
};
export default Level;